import { Drawer } from '@components/common';
import { useBjModal } from '@hooks/common/useBjModal';
import { SidebarJobSearchFiltersHub } from '@components/features/filters/hubs/SidebarJobSearchFiltersHub';
import { TopBarJobSearchFiltersHub } from '@components/features/filters/hubs/TopBarJobSearchFiltersHub';
import { JobSearchFiltersProps } from '@type/filters';

/**
 * @description The talent search filters component. It contains the top bar filters and the sidebar filters.
 * * **queryParams** - the query params object.
 * * **setQueryParams** - the function to set the query params.
 */
export const JobSearchFilters = (props: JobSearchFiltersProps) => {
  // Destructure props
  const {
    queryParams,
    setQueryParams,
    setFilterLabels,
  } = props;

  // Drawer states & functions
  const { isOpen: drawerOpen, toggleModal: toggleDrawer } = useBjModal();

  // Render component
  // **********************************************
  return (
    <>
      {/* TOP BAR FILTERS */}
      <div className="border-b border-input/50 bg-surface-50">
        <div className="container">
          <div className="scrollbar overflow-auto px-0.5 py-3.5">
            <TopBarJobSearchFiltersHub
              queryParams={queryParams}
              setQueryParams={setQueryParams}
              toggleDrawer={toggleDrawer}
              setFilterLabels={setFilterLabels}
            />
          </div>
        </div>
      </div>


      {/* SIDEBAR FILTERS */}
      <Drawer
        onClose={toggleDrawer}
        isOpen={drawerOpen}
        position="right"
        panelClasses="!overflow-visible"
      >
        <SidebarJobSearchFiltersHub
          queryParams={queryParams}
          setQueryParams={setQueryParams}
          toggleDrawer={toggleDrawer}
        />
      </Drawer>

    </>
  );
};
